export function isTestEnvironment() {
  const isCypressWindow =
    process.env.NODE_ENV === 'development' && window.Cypress;
  const isCypressHeadless = process.env.NODE_ENV === 'test';
  return isCypressWindow || isCypressHeadless;
}

export function shouldUseMockApi() {
  const useMockApi = process.env.REACT_APP_USE_MOCK_API === 'true';
  return useMockApi;
}
